<template>
  <div class="bill-filter">
    <b-row class="mb-4">
      <b-col cols="3">
        <div class="date-style">
          <b-input-group>
            <date-picker
              placeholder="Từ"
              class="form-control form-control-sm"
              :config="dpConfigs.date"
              v-model="apiParams.fromDate"
            ></date-picker>
          </b-input-group>
          <span class="ml-1 mr-1"></span>
          <b-input-group>
            <date-picker
              placeholder="Đến"
              class="form-control form-control-sm"
              :config="dpConfigs.date"
              v-model="apiParams.toDate"
            ></date-picker>
          </b-input-group>
        </div>
      </b-col>
      <b-col cols="3">
        <BDropdownCustom
          v-model="apiParams.storeIds"
          :options="optionStores"
          :placeholder="'cửa hàng'"
          :searchable="true"
          :matchKey="['name', 'shortName']"
          :limit="5"
        />
      </b-col>
      <b-col cols="3">
        <Autosuggest
          :model="apiParams.customerPhoneSearch"
          :suggestions="optionsCustomerPhone"
          :suggestionName="'phoneNo'"
          :placeholder="'sđt khách hàng'"
          :limit="10"
          @select="onSelectedCustomerPhone"
          @change="onChangeCustomerPhone"
        >
          <template #custom="{ suggestion }">
            <div class="d-flex flex-column">
              <span class="text-primary mb-1" v-if="suggestion.item.phoneNo"
                >({{ suggestion.item.phoneNo }})</span
              >
              <span>{{ suggestion.item.fullName }}</span>
            </div>
          </template>
        </Autosuggest>
      </b-col>
      <b-col cols="3">
        <b-input
          placeholder="Nhập ghi chú hóa đơn"
          v-model="apiParams.billNote"
          autocomplete="off"
          size="sm"
        />
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="3">
        <b-input
          placeholder="Nhập tên sản phẩm"
          v-model="apiParams.productSearch"
          autocomplete="off"
          size="sm"
        />
      </b-col>
      <b-col cols="3">
        <b-input
          placeholder="Nhập mã IMEI"
          v-model="apiParams.imeiSearch"
          autocomplete="off"
          size="sm"
        />
      </b-col>
      <b-col cols="3">
        <b-input
          placeholder="Nhập ghi chú bán hàng"
          v-model="apiParams.saleNote"
          autocomplete="off"
          size="sm"
        />
      </b-col>
      <b-col cols="3">
        <BDropdownCustom
          v-model="apiParams.criteriaIds"
          :options="optionCriterias"
          :placeholder="'đặc điểm'"
          :searchable="true"
          :matchKey="['name']"
        />
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="3">
        <b-input
          placeholder="Nhập ID hóa đơn trả hàng"
          v-model="apiParams.billId"
          size="sm"
          autocomplete="off"
          v-focus
        ></b-input>
      </b-col>
      <b-col cols="3">
        <b-input
          placeholder="Nhập ID hóa đơn bán hàng"
          v-model="apiParams.returnFromBillNumber"
          size="sm"
          autocomplete="off"
          v-focus
        ></b-input>
      </b-col>
      <b-col cols="3">
        <b-form-select
          v-model="apiParams.adjReturnBillStatus"
          :options="adjReturnBillStatusOptions"
          size="sm"
          style="min-width: 170px"
        />
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="6">
        <div class="einvoice-filter-group">
          <span class="einvoice-filter-label">HĐĐT:</span>

          <div class="einvoice-segment-control">
            <button
              type="button"
              class="segment-btn"
              :class="{ 'is-active': apiParams.hasAdjustEinvoice === null }"
              @click="setAdjustEinvoiceFilter(null)"
            >
              Tất cả
            </button>

            <button
              type="button"
              class="segment-btn segment-btn--has"
              :class="{ 'is-active': apiParams.hasAdjustEinvoice === true }"
              @click="setAdjustEinvoiceFilter(true)"
            >
              <i class="fas fa-file-invoice mr-1"></i>
              Có HĐĐT
            </button>

            <button
              type="button"
              class="segment-btn segment-btn--none"
              :class="{ 'is-active': apiParams.hasAdjustEinvoice === false }"
              @click="setAdjustEinvoiceFilter(false)"
            >
              <i class="fas fa-file-circle-question mr-1"></i>
              Chưa có
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col>
        <b-button-group size="sm">
          <b-button
            style="width: 70px"
            class="font-weight-bolder"
            variant="primary"
            @click="onFilter"
            ><i class="fas fa-search text-white fa-lg"></i>Lọc</b-button
          >
        </b-button-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import timeUtils from '@/utils/date';
import { cloneDeep } from 'lodash';
import ApiService from '@/core/services/api.service';
import { removeAccents } from '@/utils/common';
import { TIME_TRIGGER, CRITERIA } from '@/utils/constants';
import {
  RETURN_BILL_ADJUSTMENT_LIST_FILTER,
  RETURN_BILL_ADJUSTMENT_LIST_FILTER_OPTIONS,
} from '@/utils/enum';
import decounce from 'debounce';

export default {
  mixins: [apiCommonMixin],
  name: 'RefundBillFilter',
  components: {
    BDropdownCustom,
    Autosuggest,
  },
  data() {
    return {
      apiParams: {
        fromDate: timeUtils.getSubtractDate(15),
        toDate: '',
        storeIds: [],
        criteriaIds: [],
        productSearch: '',
        imeiSearch: '',
        billId: '',
        orderId: '',
        customerPhoneSearch: '',
        billNote: '',
        saleNote: '',
        adjReturnBillStatus: RETURN_BILL_ADJUSTMENT_LIST_FILTER.ALL,
        hasAdjustEinvoice: null,
      },
      dpConfigs: timeUtils.DP_CONFIG,
      optionOrigin: {
        employees: [],
        stores: [],
      },
      optionStores: [],
      filteredOptionsCustomerPhone: [],
      isSearchingCustomerPhone: false,
      optionCriterias: CRITERIA,
    };
  },
  computed: {
    adjReturnBillStatusOptions() {
      return RETURN_BILL_ADJUSTMENT_LIST_FILTER_OPTIONS;
    },
    optionsCustomerPhone() {
      return cloneDeep(this.filteredOptionsCustomerPhone);
    },
  },
  watch: {
    $props: {
      handler() {},
      deep: true,
      immediate: true,
    },
    apiParams: {
      handler(newVal) {
        this.$emit('update-filter', newVal);
      },
      deep: true,
      immediate: false,
    },
  },
  async created() {
    const { stores, currentStoreId, currentStoreName } =
      await this.fetchStoreByUser();
    this.optionStores = stores;
    this.optionOrigin.stores = stores;
    if (currentStoreId) {
      const currentStore = {
        id: currentStoreId,
        name: currentStoreName,
      };
      this.apiParams.storeIds = [currentStore];
    }
    this.onFilter();
  },
  mounted() {
    window.addEventListener('keyup', this.onFilterKeyEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onFilterKeyEnter);
  },
  methods: {
    onFilterKeyEnter(event) {
      if (event.key === 'Enter') {
        this.onFilter();
      }
    },
    fitlerOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameWTUnicode = removeAccents(item[prop] || '');
            const nameInputWTUnicode = removeAccents(textInput);
            const index = nameWTUnicode
              .toLowerCase()
              .indexOf(nameInputWTUnicode.toLowerCase());

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },
    fetchStores() {
      ApiService.query('stores/getStores').then((response) => {
        if (response.data.status) {
          const stores = response.data.data;
          this.optionStores = stores;
          this.optionOrigin.stores = stores;
        }
      });
    },
    searchCustomer() {
      const searchText = this.apiParams.customerPhoneSearch;
      this.isSearchingCustomerPhone = true;
      this.filteredOptionsCustomerPhone = [];

      ApiService.get(`customer/get-by-phone?phoneNumber=${searchText}`).then(
        (data) => {
          const customers = data.data.data;
          this.filteredOptionsCustomerPhone = customers || [];
          this.isSearchingCustomerPhone = false;
        },
      );
    },
    debounceSearchCustomerPhone: decounce(function () {
      if (!this.isSearchingCustomerPhone) {
        this.searchCustomer();
      }
    }, TIME_TRIGGER),
    onChangeCustomerPhone(textInput) {
      const searchText = textInput ? textInput.trim() : null;
      this.apiParams.customerPhoneSearch = searchText;
      this.debounceSearchCustomerPhone();
    },
    onSelectedCustomerPhone(option) {
      if (!option) return;
      this.apiParams.customerPhoneSearch = option.item.phoneNo;
    },
    getSuggestionCustomerPhoneValue(suggestion) {
      return suggestion.item.phoneNo;
    },
    onFilter() {
      this.$emit('filter', this.apiParams);
    },
    setAdjustEinvoiceFilter(value) {
      this.apiParams.hasAdjustEinvoice = value;
    },
  },
};
</script>

<style lang="scss">
.bill-filter {
  .checkbox-style {
    position: absolute;
    right: 0.7vw;
  }

  .custom-card-body {
    padding: 0 2.25rem;
  }

  .date-style {
    display: flex;
    align-items: center;
  }

  .select-style {
    border-radius: 0.28rem;
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  input.form-control {
    border: 1px solid #ced4da;
  }

  .multiselect__tags {
    height: calc(1.35em + 1.1rem + 2px);
    display: block;
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    font-size: 0.925rem;
    min-height: initial;
    padding-top: 0.3rem;
  }

  .multiselect__select {
    width: 3rem;
    height: 2.5rem;
    top: 0.1rem;
  }

  .multiselect__placeholder {
    color: #495057;
    padding-left: 0.2rem;
  }

  .multiselect__element {
    font-size: 0.925rem;
  }

  .multiselect__input {
    padding-top: 0.2rem;
    font-size: 0.925rem;
  }

  .multiselect__single {
    font-size: 0.925rem;
    line-height: 1.9;
    padding-left: 0.2rem;
    display: inline-block;
    max-width: 100%;
  }

  .autosuggest__results {
    position: absolute;
    width: 100%;
    max-height: 200px;
    z-index: 999;
    border: 1px solid #e0e0e0;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: #fff;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  .autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.35em + 1.1rem + 2px);
    line-height: 1.35;
    padding: 0.55rem 0.75rem;
    font-weight: 400;
    font-size: 0.925rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.28rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .autosuggest__input:focus {
    outline: none !important;
    border: 1px solid #92c5f9;
  }

  .autosuggest__results-item:hover {
    background-color: #ddd;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }
  #autosuggest {
    width: 100%;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(11% - 0.25rem);
    background-color: #f0f1f9;
  }

  .wizard.wizard-4
    .wizard-nav
    .wizard-steps
    .wizard-step[data-wizard-state='current'] {
    background-color: #ffffff;
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .collapsing {
    -webkit-transition: none;
    transition: none;
    display: none;
  }
  .togge-filter {
    background-color: #3d8cdd;
    border-color: #3d8cdd;
  }

  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .einvoice-filter-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .einvoice-filter-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
  }

  .einvoice-segment-control {
    display: inline-flex;
    background: #f1f3f5;
    border-radius: 6px;
    padding: 3px;
    gap: 2px;
  }

  .segment-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    background: transparent;
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover:not(.is-active) {
      background: #e9ecef;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
    }

    i {
      font-size: 11px;
    }

    &.is-active {
      background: #fff;
      color: #212529;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
  }

  .segment-btn--has.is-active {
    background: #d3f9d8;
    color: #2b8a3e;
    box-shadow: none;
  }

  .segment-btn--none.is-active {
    background: #fff9db;
    color: #e67700;
    box-shadow: none;
  }
}
</style>
